export function returnOnCatch(error) {
    console.error("Error Delete entity:", error);
    return { passed: false, message: "An error has occurred, please check the logs", entityId: "" };
}
export function returnOnFail() {
    var message = "An error has occurred, please check the logs";
    return { passed: false, message: message, entityId: "" };
}
